import React from 'react';
import { Box, Typography } from '@mui/material';
import FuncionarioForm from '../components/funcionario/FuncionarioForm';

const FuncionarioEditar: React.FC = () => {
  return (
    <Box>
      <Typography 
        variant="h4" 
        component="h1" 
        gutterBottom 
        sx={{ 
          fontWeight: 'bold',
          fontFamily: 'Arial, sans-serif',
          fontSize: '2.125rem',
          lineHeight: 1.235
        }}
      >
        Editar Funcionário
      </Typography>
      <FuncionarioForm isEdit={true} />
    </Box>
  );
};

export default FuncionarioEditar;
